import React, { useContext } from 'react'

import { useTheme } from '@emotion/react'
import { AppState, useFeature } from '@news-mono/web-common'
import { RenderTargetContext } from '@news-mono/web-common'
import {
    StyledTheWestHeader,
    StyledHeaderTimestamp,
    StyledChevronRight,
    StyledSubscribeButton,
    StyledSubscribeIcon,
    StyledTimestampWrap,
    StyledTheWestHeaderWrapper,
    StyledWestRewardsIcon,
    StyledWestRewardsLink,
    StyledLeftWrapper,
} from '../../content/TheWestHeader/TheWestHeader.styled'
import { InHouseLinks } from '../../content/TheWestHeader/components/InHouseLinks'
import { CricketAnimation } from '../../content/TheWestHeader/components/CricketAnimation'
import { MastHeadLogo } from './logos/MastheadLogo'
import { AuthenticationProvider } from '../../user-registration/authentication/AuthenticationProvider'
import { createSubscribeLinkClickEvent } from '../../user-registration/subscribe/createSubscribeClickLinkHandler'
import { EntitledToView } from '../../user-registration/entitlements/EntitledToView'
import { FeatureToggle } from '../../feature-toggling/Toggle/Toggle'
import { TheWestHeaderProps } from './TheWestHeader'
import { featurePublicationPageType } from '../../templates/Publication/TheWestPublication/TheWestFeature'
import { useSelector } from 'react-redux'

const SubscribeButton: React.FC<{
    onEvent: (event: any) => void
    cricketballEnabled: boolean
}> = ({ onEvent, cricketballEnabled }) => {
    const renderTarget = useContext(RenderTargetContext)

    return renderTarget.renderTarget === 'static-error-page' ? null : (
        <AuthenticationProvider onEvent={onEvent}>
            {({ onSubscribeClick }) => (
                <StyledSubscribeButton
                    onClick={() => {
                        createSubscribeLinkClickEvent('header', onEvent)()
                        onSubscribeClick()
                    }}
                    shouldShrink={cricketballEnabled}
                >
                    <StyledSubscribeIcon />
                    Subscribe <StyledChevronRight />
                </StyledSubscribeButton>
            )}
        </AuthenticationProvider>
    )
}

export const TheWestHeaderWeb: React.FC<TheWestHeaderProps> = (props) => {
    const renderTarget = useContext(RenderTargetContext)
    const { section } = useTheme()
    const { subscriptionType } = useSelector(
        (state: AppState) => state.authentication,
    )

    const { className, inHouseLinks, onEvent } = props

    const cricketballEnabled =
        useFeature('cricketball') && section === 'default'

    const showWestRewardsOrSubscribe = subscriptionType !== 'corporate-site'

    const isRegionalSite = section !== 'default'

    const showDivider =
        (!cricketballEnabled &&
            props.pageType !== featurePublicationPageType) ||
        isRegionalSite

    return (
        <StyledTheWestHeaderWrapper>
            <StyledTheWestHeader
                showDivider={showDivider}
                className={className}
            >
                <StyledLeftWrapper>
                    {showWestRewardsOrSubscribe && (
                        <FeatureToggle
                            feature="the-west-rewards"
                            on={() => (
                                <EntitledToView
                                    requiredAccess={{ level: 'subscriber' }}
                                    entitled={() => (
                                        <StyledWestRewardsLink to="https://rewards.thewest.com.au/?utm_source=TheWest&utm_medium=Referral&utm_campaign=WestRewards&utm_term=icon&utm_content=header-nav">
                                            <StyledWestRewardsIcon />
                                        </StyledWestRewardsLink>
                                    )}
                                    notEntitled={() => (
                                        <SubscribeButton
                                            onEvent={onEvent}
                                            cricketballEnabled={
                                                cricketballEnabled
                                            }
                                        />
                                    )}
                                ></EntitledToView>
                            )}
                            off={() => (
                                <SubscribeButton
                                    onEvent={onEvent}
                                    cricketballEnabled={cricketballEnabled}
                                />
                            )}
                        />
                    )}
                </StyledLeftWrapper>

                <MastHeadLogo />
                <StyledTimestampWrap>
                    {inHouseLinks && <InHouseLinks items={inHouseLinks} />}
                    {renderTarget.renderTarget === 'static-error-page' ||
                    renderTarget.renderTarget === 'amp' ? null : (
                        <StyledHeaderTimestamp
                            className={className}
                            timestamp={Date.now()}
                            timestampFormat="dateOnly"
                        />
                    )}
                </StyledTimestampWrap>
                {cricketballEnabled && <CricketAnimation />}
            </StyledTheWestHeader>
        </StyledTheWestHeaderWrapper>
    )
}
TheWestHeaderWeb.displayName = 'TheWestHeader'
